import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';

import { usePlaylistReconciliation } from '@/domains/productDiscovery/Recommendation/modules/ProductRecommendation/hooks/usePlaylistReconciliation';

import { useDetail } from './useDetail';

/**
 * This hook will clear the playlist fingerprint and reconciliation if it still has
 * the same productId value when exiting the product page
 */
export const usePlaylistReconciliationA2CTracking = (): void => {
  const router = useRouter();
  const {
    getPlaylistReconciliationFromLocalStorage,
    clearPlaylistReconciliation,
  } = usePlaylistReconciliation();
  const { productId } = useDetail();

  const clear = useCallback(() => {
    const { productId: localStorageProductId } =
      getPlaylistReconciliationFromLocalStorage();

    if (productId?.toString() === localStorageProductId) {
      clearPlaylistReconciliation();
    }
  }, [
    clearPlaylistReconciliation,
    getPlaylistReconciliationFromLocalStorage,
    productId,
  ]);

  useEffect(() => {
    window.addEventListener('unload', clear);
    router.events.on('routeChangeStart', clear);
    return () => {
      window.removeEventListener('unload', clear);
      router.events.off('routeChangeStart', clear);
    };
  }, [clear, router]);
};
